import React from 'react';

import SectionLayout from 'dpl/quiz/components/SectionLayout';
import { SECTION_CLASSES } from 'dpl/quiz/sections/components/Section';
import { PRIVACY_PATH, TOS_PATH } from 'dpl/shared/constants/urls';

export default function TelephoneSection(props) {
  return (
    <div className={SECTION_CLASSES}>
      <div>
        <SectionLayout {...props} />
        <p className="SectionSubtext ph5 f1 tertiary tc mt3 mb3">
          By clicking &lsquo;Continue&rsquo;, you consent to receive service and
          promotional text messages from Good Dog at the number provided, like
          when a breeder sends you a message. You also consent to placing and
          receiving calls from other Good Dog members routed through Good
          Dog&apos;s call relay service, which may display a unique Good Dog
          telephone number. Messages and calls may be sent or connected using
          automated systems. Consent is not a condition of any purchase. Reply
          STOP to unsubscribe from promotional messages at any time. Message and
          data rates may apply.
        </p>
        <p className="f2 mid-gray tc">
          By continuing, I agree to Good Dog&apos;s&nbsp;
          <a
            className="underline"
            href={TOS_PATH}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          &nbsp;and{' '}
          <a
            className="underline"
            href={PRIVACY_PATH}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </div>
  );
}
